import { render, staticRenderFns } from "./TicketResourceList.vue?vue&type=template&id=7e5cd65c&"
import script from "./TicketResourceList.vue?vue&type=script&lang=js&"
export * from "./TicketResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports